'use client'
import {
  SCHEDULE_QUERY
} from "./chunk-HLVUCALY.mjs";
import {
  CATEGORY_QUERY
} from "./chunk-ZZ3DUO5U.mjs";
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  CURRENCY_QUERY
} from "./chunk-PXTWVUHC.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/range.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
import { dateAdd, endOfMonth, startOfMonth } from "@wbk/utils";
var buildQuery = ({ total }) => {
  const year = (/* @__PURE__ */ new Date()).getFullYear();
  const months = Array.from({ length: total });
  return gql`
    query getRangeEvents($lang: String, $limit: Int, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
      ${months.map((_, idx) => {
    const date = dateAdd({
      date: startOfMonth(new Date(year, 0, 1)),
      interval: "month",
      value: idx
    });
    const start = startOfMonth(date);
    const end = endOfMonth(date);
    const key = `m${start.getFullYear()}${start.getMonth()}`;
    return `
            ${key}: eventCollection(
              locale: $lang
              limit: $limit
              skip: $skip
              where: {
                AND: [
                  $where
                  { schedule: { openDateTime_gt: "${start.toISOString()}", openDateTime_lt: "${end.toISOString()}" } }
                ]
              }
              order: $order
            ) {
              total
              items {
                id
                title
                slug
                image11{${IMAGE_QUERY}}
                price
                priceUnit
                currency{${CURRENCY_QUERY}}
                schedule{${SCHEDULE_QUERY}}
                category{${CATEGORY_QUERY}}
              }
            }
          `;
  }).join("\n")}
    }
  `;
};
var getRangeEvents = (props) => __async(void 0, null, function* () {
  try {
    const QUERY = buildQuery(props);
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: ["tier_ASC", "order_ASC"]
    }, props), {
      where: __spreadProps(__spreadValues({}, props.where), { visibility_not: "private" })
    }));
    return res;
  } catch (error) {
    throw new Exception({ error, name: "getRangeEventsException" });
  }
});
var useGetRangeEvents = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getRangeEvents", props],
    queryFn: () => getRangeEvents(props)
  }));
};

export {
  getRangeEvents,
  useGetRangeEvents
};
//# sourceMappingURL=chunk-NPIZF5EY.mjs.map